module.exports = __webpack_public_path__ + "img/done.4f1f8643.svg";